﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_listavalores_id: new EntityColumn<string>({ name: 'c_listavalores_id', type: 'char', length: 20, flags: c.PK, prompt: 'Listavalores Id' }),
        c_listavaloritem_id: new EntityColumn<string>({ name: 'c_listavaloritem_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Listavaloritem Id' }),
        vc_nombrelistaitem: new EntityColumn<string>({ name: 'vc_nombrelistaitem', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombrelistaitem' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        livi_brwStandard: { name: 'livi_brwStandard', keyMappings: { c_listavalores_id: 0 } }
    }
)

export class ListasValoresItemsDef extends EntityDefinition {

    columns = columns();
    views = views();

    constructor() {
        super('ListasValoresItems');
    }
}